<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>员工中心</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="isHideDetails = false">收藏列表</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!isHideDetails">
      <section class="searchBox">
        <a-input
          v-model="nameSearch"
          placeholder="请输入简历姓名、收藏用户的姓名、简历手机号码"
        />
        <a-button style="margin-right:10px" @click="onReset">重置</a-button>
        <a-button type="primary" icon="search" @click="onSearch">搜索</a-button>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>
                {{
                  item.update_time != undefined && item.update_time != ""
                    ? item.update_time.substring(0, 10)
                    : "---"
                }}
              </td>
              <td>{{ item.collection_user_name }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.address }}</td>
              <td></td>
              <td>{{ item.resume_wish }}</td>
              <td>
                {{
                  item.communicate_record_info == ""
                    ? ""
                    : item.communicate_record_info[0].communicate
                }}
              </td>
              <td class="operation">
                <a @click="detailPage(item.resume_id)">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 详情 -->
    <resumeDetail v-show="isHideDetails" :detailID="detailID" />
    <!-- 详情 end-->
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import resumeDetail from "@/components/resume/resumeDetail.vue";
export default {
  components: {
    resumeDetail
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      hideInAddMap: false,
      query_field: "",
      hideInUserEdit: false,
      editDetail: {},
      totalPage: Number,
      nameSearch: "",
      thList: [
        "更新时间",
        "运营姓名",
        "员工姓名",
        "地址",
        "简历来源",
        "意愿",
        "最近一个沟通记录",
        "操作"
      ],
      hideInAddMapOne: false,
      isHideDetails: false,
      detailID: "",
      date: undefined
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    detailPage(id) {
      this.detailID = id;
      this.isHideDetails = true;
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },

    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Resume_admin/queryAllCollectionList";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.nameSearch,
          token: window.localStorage.getItem("xnwfPcToken"),
          willingness: -1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    onReset() {
      this.date = undefined;
      this.nameSearch = "";
      this.page = 1;
      this.getData();
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    justify-content: flex-end;
    input {
      width: 360px;
      margin-right: 20px;
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
